import * as Yup from "yup";

// Define the base schema for questions with comments
const questionSchema = Yup.object().shape({
  answer: Yup.string()
    .oneOf(["yes", "no", "n/a"], "Answer must be one of: yes, no, or n/a")
    .required("Response Value is Required"),
  comment: Yup.string(),
});

// Define the base schema for questions without comments
const questionSchemaWithoutComments = Yup.object().shape({
  answer: Yup.string()
    .oneOf(["yes", "no", "n/a"], "Answer must be one of: yes, no, or n/a")
    .required("Response Value is Required"),
});

// Define the schema for compliance percentage
const complianceSchema = Yup.object().shape({
  percentage: Yup.number()
    .max(1, "Can't be higher than 1")
    .min(0, "Can't be lower than 0")
    .required("Compliance percentage is required"),
});

export const diningAuditValidationSchema = Yup.object().shape({
  facility: Yup.string().required("Facility name is required"),
  unit: Yup.string().required("Unit name is required"),
  auditedBy: Yup.string().required("Auditor's name is required"),
  startDate: Yup.date().required("Start date is required"),
  endDate: Yup.date().required("End date is required"),
  auditCompletedFor: Yup.string().required("Audit completion name is required"),
  mealObserved: Yup.string().required("Meal observed is required"),
  snackAudit: Yup.object().shape({
    q1: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q2: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q3: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q4: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q5: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q6: Yup.object().shape({
      part1: questionSchemaWithoutComments,
      part2: questionSchemaWithoutComments,
      part3: questionSchemaWithoutComments,
      part4: questionSchemaWithoutComments,
    }),
    q7: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q8: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q9: Yup.object().shape({
      part1: questionSchemaWithoutComments,
      part2: questionSchemaWithoutComments,
      part3: questionSchemaWithoutComments,
    }),
    q10: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q11: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q12: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q13: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q14: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q15: Yup.object().shape({
      part1: questionSchemaWithoutComments,
      part2: questionSchemaWithoutComments,
      part3: questionSchemaWithoutComments,
    }),
    q16: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q17: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    q18: Yup.object().shape({ part1: questionSchemaWithoutComments }),
    comments: Yup.string(),
    actionPlan: Yup.string().required("Action Plan is required"),
    followUpDate: Yup.date().required("Follow-up date is required"),
    compliance: complianceSchema,
  }),
  diningAudit: Yup.object().shape({
    environment: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
      q4: questionSchema,
      q5: questionSchema,
      compliance: complianceSchema,
    }),
    setup: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
      compliance: complianceSchema,
    }),
    assistance: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
      q4: questionSchema,
      q5: questionSchema,
      q6: questionSchema,
      compliance: complianceSchema,
    }),
    activities: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
      q4: questionSchema,
      q5: questionSchema,
      q6: questionSchema,
      compliance: complianceSchema,
    }),
    interruption: Yup.object().shape({
      q1: questionSchema,
      q2: questionSchema,
      q3: questionSchema,
      q4: questionSchema,
      compliance: complianceSchema,
    }),
    notes: Yup.string(),
  }),
});
